module.exports = __webpack_public_path__ + "static/media/monthly10_on.43ad1010.png";